import { h } from 'preact'
import UserAvatar from '../User/UserAvatar'

interface Props {
  lastPostAuthor: Object,
  lastPostUrl: string,
  lastPostRelativeCreationDate: string
}

const TopicLastPost = ({ lastPostAuthor, lastPostUrl, lastPostRelativeCreationDate }: Props) => {
  return (
    <span className='thread-meta-item thread-meta-item--last-update thread-meta-item--hover-highlight'>
      <UserAvatar
        user={lastPostAuthor}
        extraClass='avatar--XS thread-meta-item__icon'
        showRank
      />

      <a
        className='qa-topic-meta-last-post-date-link'
        href={lastPostUrl}
      >
        <span className='thread-meta-item__text'>
          {lastPostRelativeCreationDate}
        </span>
      </a>
    </span>
  )
}

export default TopicLastPost
